import { BOOKMARKLET_HREF } from 'virtual:bookmarklet-href';

interface Props { onClose: () => void }

/** Modal with the draggable "Capture to Canvas" bookmarklet + usage legend. */
export function BookmarkletModal({ onClose }: Props) {
  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 299, background: 'rgba(0,0,0,.4)' }} />
      <div
        style={{
          position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%,-50%)', zIndex: 300,
          width: 440, background: 'var(--color-menu-bg)', border: '1px solid var(--color-border)',
          borderRadius: 12, boxShadow: 'var(--shadow-2)', padding: 20,
          color: 'var(--color-text)', fontFamily: 'var(--font-mono)', fontSize: 13, lineHeight: 1.6,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{ margin: '0 0 8px', fontSize: 16 }}>Capture to Canvas</h2>
        <p style={{ margin: '0 0 14px', color: 'var(--color-text-muted)' }}>
          Drag this button to your bookmarks bar. On any page, click it, then pick an element.
        </p>
        <a
          href={BOOKMARKLET_HREF}
          onClick={(e) => e.preventDefault()}
          draggable
          style={{
            display: 'inline-block', background: 'var(--color-accent)', color: '#fff', textDecoration: 'none',
            padding: '8px 16px', borderRadius: 8, fontWeight: 700, cursor: 'grab',
          }}
        >
          📸 Capture to Canvas
        </a>
        <ul style={{ margin: '16px 0 0', paddingLeft: 18, color: 'var(--color-text-muted)' }}>
          <li><b>↑ / ↓</b> — walk up/down the DOM tree</li>
          <li><b>Enter</b> / click — copy element (paste with <b>⌘V</b>)</li>
          <li><b>Shift+Enter</b> — copy whole page as live embed (paste with <b>⌘⇧V</b>)</li>
          <li><b>Esc</b> — exit the picker</li>
        </ul>
        <p style={{ margin: '12px 0 0', fontSize: 11, color: 'var(--color-text-muted)' }}>
          Needs an HTTPS page for clipboard access. Captures are static (no JS) except whole-page live embeds.
        </p>
        <div style={{ textAlign: 'right', marginTop: 14 }}>
          <button
            onClick={onClose}
            style={{
              background: 'var(--color-surface-2)', color: 'var(--color-text)',
              border: '1px solid var(--color-border)', borderRadius: 6, padding: '6px 14px', cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
}
